var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_64_1726)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.192 5.465C21.3795 5.65253 21.4848 5.90684 21.4848 6.172C21.4848 6.43716 21.3795 6.69147 21.192 6.879L9.95 18.122C9.84785 18.2242 9.72656 18.3053 9.59307 18.3606C9.45958 18.4159 9.3165 18.4444 9.172 18.4444C9.0275 18.4444 8.88442 18.4159 8.75093 18.3606C8.61744 18.3053 8.49615 18.2242 8.394 18.122L2.808 12.536C2.71509 12.4431 2.64139 12.3328 2.59111 12.2114C2.54082 12.09 2.51494 11.9599 2.51494 11.8285C2.51494 11.6971 2.54082 11.567 2.59111 11.4456C2.64139 11.3242 2.71509 11.2139 2.808 11.121C2.90091 11.0281 3.01121 10.9544 3.1326 10.9041C3.254 10.8538 3.38411 10.8279 3.5155 10.8279C3.6469 10.8279 3.777 10.8538 3.8984 10.9041C4.01979 10.9544 4.13009 11.0281 4.223 11.121L9.173 16.071L19.777 5.465C19.9645 5.27753 20.2188 5.17221 20.484 5.17221C20.7492 5.17221 21.0045 5.27753 21.192 5.465Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_64_1726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.b07212efd6a5615b22dc483c77e2a901.svg";
export { ForwardRef as ReactComponent };